import { MovieClipSoundStream } from './MovieClipSoundStream';
import { release } from '../base/utilities/Debug';
var MovieClipSoundsManager = /** @class */ (function () {
    function MovieClipSoundsManager() {
        this.lastFrameNum = -2;
        this._soundStreams = [];
        this._frameToSoundStream = {};
    }
    MovieClipSoundsManager.addActiveSound = function (sound) {
        //console.log("start sound with id", sound.id)
        if (!MovieClipSoundsManager.activeSounds[sound.id]) {
            MovieClipSoundsManager.activeSounds[sound.id] = {};
        }
        MovieClipSoundsManager.activeSounds[sound.id].active = true;
        MovieClipSoundsManager.activeSounds[sound.id].sound = sound;
    };
    MovieClipSoundsManager.enterFrame = function () {
        for (var key in MovieClipSoundsManager.activeSounds) {
            //console.log("set sound to inactive", key)
            var sound = MovieClipSoundsManager.activeSounds[key];
            sound.active = false;
        }
    };
    MovieClipSoundsManager.exitFrame = function () {
        for (var key in MovieClipSoundsManager.activeSounds) {
            var sound = MovieClipSoundsManager.activeSounds[key];
            if (!sound.active) {
                //console.log("stop inactive sound", key)
                sound.sound.stop();
                delete MovieClipSoundsManager.activeSounds[key];
            }
        }
    };
    MovieClipSoundsManager.prototype.initSoundStream = function (streamInfo) {
        this.soundStreamHead = streamInfo;
    };
    MovieClipSoundsManager.prototype.addSoundStreamBlock = function (frameNum, streamBlock) {
        if (!this.soundStreamHead) {
            release || console.log('can not add soundstreamblock if no soundstreamHead exists');
            return;
        }
        if (this._soundStreams.length == 0 || (frameNum - this.lastFrameNum) > 1) {
            this._soundStreams.push(new MovieClipSoundStream(this.soundStreamHead));
        }
        this.lastFrameNum = frameNum;
        this._soundStreams[this._soundStreams.length - 1].appendBlock(frameNum, streamBlock);
        this._frameToSoundStream[frameNum] = this._soundStreams[this._soundStreams.length - 1];
    };
    MovieClipSoundsManager.prototype.stopStream = function (frameNum) {
        if (!this._frameToSoundStream[frameNum])
            return;
        this._frameToSoundStream[frameNum].stopped = true;
    };
    MovieClipSoundsManager.prototype.resetStreamStopped = function () {
        for (var i = 0; i < this._soundStreams.length; i++) {
            this._soundStreams[i].stopped = false;
        }
    };
    MovieClipSoundsManager.prototype.syncSounds = function (frameNum, isPlaying, parent) {
        if (isPlaying && parent && this._frameToSoundStream[frameNum] && !this._frameToSoundStream[frameNum].stopped) {
            return this._frameToSoundStream[frameNum].playFrame(frameNum);
        }
        return 0;
    };
    MovieClipSoundsManager.activeSounds = {};
    return MovieClipSoundsManager;
}());
export { MovieClipSoundsManager };
